/**
 * Created with IntelliJ IDEA.
 * User: ffischer
 * Date: 16.04.13
 * Time: 08:52
 */

import { BasicPrivateOfferVO } from "../../BasicPrivateOfferVO";
import { Constants_Offer } from "../../Constants_Offer";
import { PrivateOfferStateEnum } from "../../PrivateOfferStateEnum";
import { IOfferDescriptionVisualParameter } from "./IOfferDescriptionVisualParameter";

/**
 * Visual Parameter to add a status icon button to the status panel
 */
export class OfferDescriptionVisualInterfaceButton implements IOfferDescriptionVisualParameter {
    private _buttonType: string;
    private _panelType: number;
    private _tooltipId: string;
    private _isVisible: boolean;

    constructor(buttonType: string, panelType: number, tooltipId: string, isVisible: boolean) {
        this._buttonType = buttonType;
        this._panelType = panelType;
        this._tooltipId = tooltipId;
        this._isVisible = isVisible;
    }

    public get name(): string {
        return Constants_Offer.OFFER_VISUAL_INTERFACE_BUTTON;
    }

    public parseFromObjectParam(params: any): void {
        this._buttonType = params.BT;
        this._panelType = params.PT;
        this._tooltipId = params.TID;
        this._isVisible = false;
    }

    public execute(offerVO: BasicPrivateOfferVO): boolean {
        if (offerVO.offerState === PrivateOfferStateEnum.QUEST_STARTED || offerVO.offerState === PrivateOfferStateEnum.QUEST_PENDING || offerVO.offerState === PrivateOfferStateEnum.OFFER_READY || offerVO.offerState === PrivateOfferStateEnum.OFFER_PENDING) {
            if (!this._isVisible) {
                if (!this.IsInvisbleAtExecutionHook()) {
                    return false;
                }

            }
        }
        else {
            if (this._isVisible) {
                if (!(this.isVisibleAtExecutionHook())) {
                    return false;
                }
            }
        }
        return true;
    }

    protected IsInvisbleAtExecutionHook(): boolean {
        // can be overriden
        return true;

    }

    protected isVisibleAtExecutionHook(): boolean {
        // can be overriden
        return true;
    }

    public toExecuteInState(state: PrivateOfferStateEnum): boolean {
        return true; // execute in all states
    }

    public dispose(): void {
        this._buttonType = null;
        this._tooltipId = null;
    }

    public get buttonType(): string {
        return this._buttonType;
    }

    public get panelType(): number {
        return this._panelType;
    }

    public get tooltipId(): string {
        return this._tooltipId;
    }

    public get isVisible(): boolean {
        return this._isVisible;
    }

    public getCommandName(): string {
        return "PRIVATE_OFFER_INTERFACE_BUTTON";
    }
}
